namespace TabAurous.Common {
    export interface _ExcelImportResponse extends Serenity.ServiceResponse {
        Products?: Inventory.OpeningStockItemsRow[];
        Issues?: Issue[];
        RateIssues?: RateIssues[];
    }
}
